import React from 'react';
import {
  Chat,
  Contact,
  Conversations,
  Login,
  Profile,
  ProfileContact,
} from 'components/src';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { routesName } from 'core/src';

const Stack = createNativeStackNavigator();

// Configure linking
const linking = {
  prefixes: ['http://localhost:3002', 'https://pwa.payam.holding5040.ir'],
  config: {
    screens: {
      [routesName.CONVERSATIONS]: 'conversations',
      [routesName.CHAT]: 'chat',
      [routesName.CONTACT]: 'contact',
      [routesName.PROFILE]: 'profile',
      [routesName.PROFILECONTACT]: 'profileContact',
      [routesName.LOGIN]: 'login',
    },
  },
};

const Routes = ({ token }: { token: string }) => {
  return (
    <NavigationContainer linking={linking}>
      <Stack.Navigator>
        {Boolean(token) ? (
          <>
            <Stack.Screen
              name={routesName.CONVERSATIONS}
              component={Conversations}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name={routesName.CHAT}
              component={Chat}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name={routesName.CONTACT}
              component={Contact}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name={routesName.PROFILE}
              component={Profile}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name={routesName.PROFILECONTACT}
              component={ProfileContact}
              options={{ headerShown: false }}
            />
          </>
        ) : (
          <Stack.Screen
            name={routesName.LOGIN}
            component={Login}
            options={{ headerShown: false }}
          />
        )}
      </Stack.Navigator>
    </NavigationContainer>
  );
};

export { Routes };
